/* eslint-disable */
import * as Types from '../../../models/schema';

import { SuggestionFragment_DomainSuggestion_DTO, SuggestionFragment_FaqSuggestion_DTO } from '../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import { SuggestionFragmentDTO } from '../../../graphql/models/fragments';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateSuggestionVariablesDTO = Types.Exact<{
  data: Types.Scalars['SuggestionCreateInput'];
}>;


export type CreateSuggestionDTO = (
  { __typename?: 'Mutation' }
  & { createOneSuggestion: (
    { __typename?: 'DomainSuggestion' }
    & SuggestionFragment_DomainSuggestion_DTO
  ) | (
    { __typename?: 'FaqSuggestion' }
    & SuggestionFragment_FaqSuggestion_DTO
  ) }
);


export const CreateSuggestionDocumentDTO = gql`
    mutation createSuggestion($data: SuggestionCreateInput!) {
  createOneSuggestion(data: $data) {
    ...suggestionFragment
  }
}
    ${SuggestionFragmentDTO}`;
export type CreateSuggestionMutationFnDTO = Apollo.MutationFunction<CreateSuggestionDTO, CreateSuggestionVariablesDTO>;

/**
 * __useCreateSuggestion__
 *
 * To run a mutation, you first call `useCreateSuggestion` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSuggestion` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSuggestion, { data, loading, error }] = useCreateSuggestion({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSuggestion(baseOptions?: Apollo.MutationHookOptions<CreateSuggestionDTO, CreateSuggestionVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSuggestionDTO, CreateSuggestionVariablesDTO>(CreateSuggestionDocumentDTO, options);
      }
export type CreateSuggestionHookResult = ReturnType<typeof useCreateSuggestion>;
export type CreateSuggestionMutationResultDTO = Apollo.MutationResult<CreateSuggestionDTO>;
export type CreateSuggestionMutationOptionsDTO = Apollo.BaseMutationOptions<CreateSuggestionDTO, CreateSuggestionVariablesDTO>;